
import React, { useState, useEffect } from 'react';
import { 
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import Services from '../services';
import AsyncSelect  from 'react-select/async';
import NumberFormatter from '../../../commons/NumberFormatter';
import _ from 'lodash';
import moment from 'moment';
import { DatePicker } from '../../../commons/controls';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';
import PriceInputComponent from '../../../components/Form/PriceInputComponent';
import { calculatePrice } from '../../../components/Form/PriceCalculator';
import TimeFormatter from '../../../commons/TimeFormatter';


const ROW_STYLE = { marginBottom: '15px' };
const SzallitoiCikkForm = props => {
    const {
      id,
      parentId,
      globals,
      isBontas,
      isElkuldott,
      cikkek,
      penznem,
      setCikkek,
      toggleShowCikk, 
    } = props;

    const [cikkCsoportArray, setCikkcsoportArray] = useState([]);
    const [cikk, setCikk] = useState(null);
    const [cikkNev, setCikkNev] = useState('');
    const [newCikk, toggleNewCikk] = useState(false);
    const [mennyiseg, setMennyiseg] = useState('');
    const [visszaMennyiseg, setVisszaMennyiseg] = useState(null);
    const [hatarido, setHatarido] = useState(null);
    const [visszaHatarido, setVisszaHatarido] = useState(null);
    const [nettoEgysegar, setNettoEgysegar] = useState('');
    const [afaEgysegar, setAfaEgysegar] = useState('');
    const [bruttoEgysegar, setBruttoEgysegar] = useState('');
    const [nettoBeszerzesiar, setNettoBeszerzesiar] = useState('');
    const [afaBeszerzesiar, setAfaBeszerzesiar] = useState('');
    const [bruttoBeszerzesiar, setBruttoBeszerzesiar] = useState('');
    const [priceInputEgyseg, setPriceInputEgyseg] = useState(null);
    const [megjegyzes, setMegjegyzes] = useState('');
    const [cikkModal, toggleCikkModal] = useState(true);
    const [bontasArray, setBontasArray] = useState([{id: 0,  new: true, visszaMennyiseg: '', visszaHatarido: null}]);

    const { removeSpacesFromString, removeRedundantZeros } = NumberFormatter;

    useEffect(() => {
      if(id) getSzallitoiCikkRendeles();
    }, []);

    useEffect(() => {
      toggleShowCikk(cikkModal);
    }, [cikkModal]);

    const loadCikkCsoportOptions = (input, callback) => {
      if(_.isEmpty(input)) callback([]);
      Services.listCikkCsoport({param: input}, (err, res) => {
        if(!err){
          const options = res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase()))
          callback(options);
        }else{
          callback([]);
        }
      });
    }

    const loadCikkOptions =  (input, callback) => {
      if(_.isEmpty(input)) callback([]);
      Services.listCikk({param: input, receptura: false, csoportIds: (cikkCsoportArray && cikkCsoportArray.map(cs => cs.id)) || [], datum: TimeFormatter.formatDate(props.kelte)}, (err, res) => {
        if(!err){
          const options = res[0].filter( k => k.megnevezes.toLowerCase().includes(input.toLowerCase()))
          callback(options);
        }else{
          callback([]);
        }
      });
    }

    const generateUUID = () => {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    }

    const getSzallitoiCikkRendeles = () => {
      const edited = cikkek.find(c => c.id == id);
      if(edited){
        toggleNewCikk(edited.new);
        setCikk(edited.cikk);
        setCikkNev(edited.cikkNev);
        setMennyiseg(edited.mennyiseg);
        setHatarido(edited.hatarido);
        setNettoEgysegar(edited.nettoEgysegar);
        setAfaEgysegar(removeRedundantZeros((edited.bruttoEgysegar - edited.nettoEgysegar).toFixed(6)));
        setBruttoEgysegar(edited.bruttoEgysegar);
        setNettoBeszerzesiar(edited.nettoBeszerzesiar);
        setAfaBeszerzesiar(removeRedundantZeros((edited.bruttoBeszerzesiar - edited.nettoBeszerzesiar).toFixed(6)));
        setBruttoBeszerzesiar(edited.bruttoBeszerzesiar);
        setMegjegyzes(edited.megjegyzes);
        setPriceInputEgyseg(edited.priceInputEgyseg);
        if(!isBontas){
          setVisszaMennyiseg(edited.visszaMennyiseg);
          setVisszaHatarido(edited.visszaHatarido);
        }else{
          if(!Array.isArray(edited.bontasok)){
            edited.bontasok = [];
          }
          setBontasArray([...edited.bontasok, ...bontasArray]);
        }
      }
    }

    const handleCikkChange = (v) => {
      setCikk(v);
      setCikkNev(v ? v.megnevezes : "");
      setPriceInputEgyseg(null);
      setMennyiseg('');
      setNettoEgysegar('');
      setAfaEgysegar('');
      setBruttoEgysegar('');
      setNettoBeszerzesiar('');
      setAfaBeszerzesiar('');
      setBruttoBeszerzesiar('');
    }

    const handleMennyisegChange = (e, value) => {
      let priceArray;
      setMennyiseg(value);
      if (value && value > 0) {
        if (priceInputEgyseg) {
          priceArray = calculatePrice(bruttoEgysegar, true, cikk.aktualisAfaErtek, value, penznem && penznem.tizedesjegy);
          handleArInput(priceArray, priceInputEgyseg);
        } else if (priceInputEgyseg === false) {
          priceArray = calculatePrice(bruttoBeszerzesiar, false, cikk.aktualisAfaErtek, value, penznem && penznem.tizedesjegy);
          handleArInput(priceArray, priceInputEgyseg);
        }
      }
    }

    const handleArInput = (priceArray, nettoInput) => {
      let [nettoEgysegAr, nettoEgysegAfa, bruttoEgysegAr, nettoBeszAr, bruttoBeszAfa, bruttoBeszAr] = priceArray;
      setPriceInputEgyseg(nettoInput);
      setNettoEgysegar(nettoEgysegAr);
      setAfaEgysegar(nettoEgysegAfa);
      setBruttoEgysegar(bruttoEgysegAr);
      setNettoBeszerzesiar(nettoBeszAr);
      setAfaBeszerzesiar(bruttoBeszAfa);
      setBruttoBeszerzesiar(bruttoBeszAr);
    }

    const setBontottValue = (value, idx, field) => {
      let newVal = value;
      bontasArray[idx][field] = newVal;
      setBontasArray([...bontasArray]);
    }

    const saveSzallitoiCikkRendeles = () => {
      if (!cikk) {
        globals.addError('Cikk választása kötelező!');
        return;
      }
      if (!hatarido) {
        globals.addError('Határidő megadása kötelező!');
        return;
      }
      if(cikkek.filter(cikk => !cikk.rendelesCikkEntity).find(c => !id && c.cikkId == cikk.id)){
        globals.addError('A kiválaszott cikk már szerepel a felsorolásban!');
        return;
      }
      if(isBontas && bontasArray && mennyiseg < bontasArray.reduce((acc, curr) => acc + curr.visszaMennyiseg), 0){
        globals.addError('A bontások visszaigazolt mennyisége nem lehet több az eredetileg megadottnál!');
        return;
      }
      if (!bruttoEgysegar) {
        globals.addError('Ár megadása kötelező!');
        return;
      }

      let bontottArray;
      if (isBontas) {
        bontottArray = bontasArray.filter(b => b.mennyiseg && !isNaN(b.mennyiseg) && b.hatarido);
        if (bontottArray.length < 2) {
          globals.addError('A bontás során legalább kettő mennyiséggel és határidővel töltött részre kell bontani a cikket!');
          return;
        }
        if (bontottArray.some(b => b.mennyiseg <= 0)) {
          globals.addError('Nulla vagy annál kisebb mennyiség nem megengedett!');
          return;
        }
        if (bontottArray.reduce((prevValue, currentObj) => prevValue + Number(currentObj.mennyiseg), 0) != mennyiseg) {
          globals.addError('A bontások mennyiségének összege nem egyezik meg a bontott cikk mennyiségével!');
          return;
        }
        if (bontottArray.some(b => !!b.visszaHatarido ^ !!b.visszaMennyiseg)) {
          globals.addError('A visszaigazolt mennyiség és határidő megadása kötelező együttesen!');
          return;
        }
        // Egy új bontott határidő egyezhet az eredeti határidővel, ezt engedélyezi ez a változó
        let throwErrorOnMatch = false;
        for (let i = 0; i < bontottArray.length - 1; i++) {
          const bElso = bontottArray[i];
          for (let o = i + 1; o < bontottArray.length; o++) {
            const bMasodik = bontottArray[o];
            const bElsoMoment = TimeFormatter.formatDate(moment(bElso.hatarido).utcOffset(0));
            const bMasodikMoment = TimeFormatter.formatDate(moment(bMasodik.hatarido).utcOffset(0));
            // TODO optimalizálni a futásidőt vagy az egész ellenőrzést, ha gondot jelent
            if (bElsoMoment == bMasodikMoment || ((bElsoMoment == hatarido) && throwErrorOnMatch)  || ((bMasodikMoment == hatarido) && throwErrorOnMatch)) {
              globals.addError('A bontás utáni határidőknek egyedieknek kell lenniük egymáshoz képest!');
              return;
            }
            if (!throwErrorOnMatch && (bElsoMoment == hatarido || bMasodikMoment == hatarido)) {
              throwErrorOnMatch = true;
            }
          }
        }
      }

      if (isNaN(Number(mennyiseg))) {
        globals.addError('Nem megfelelő mennyiség formátum!');
        return;
      }

      if (!id) {
        let submitObj = {};
        submitObj.id = generateUUID();
        submitObj.new = true;
        submitObj.cikk = cikk;
        submitObj.cikkNev = cikkNev;
        submitObj.cikkId = cikk && cikk.id;
        submitObj.mennyiseg = mennyiseg;
        submitObj.visszaMennyiseg = visszaMennyiseg;
        submitObj.hatarido = hatarido ? TimeFormatter.formatDate(hatarido) : null;
        submitObj.visszaHatarido =  visszaHatarido ? TimeFormatter.formatDate(visszaHatarido) : null;
        submitObj.nettoEgysegar = nettoEgysegar;
        submitObj.bruttoEgysegar = Number(removeSpacesFromString(bruttoEgysegar));
        submitObj.nettoBeszerzesiar = nettoBeszerzesiar;
        submitObj.bruttoBeszerzesiar = Number(removeSpacesFromString(bruttoBeszerzesiar));
        submitObj.megjegyzes = megjegyzes;
        submitObj.priceInputEgyseg = priceInputEgyseg;
        if(isBontas){
          submitObj.bontasok = bontasArray.filter(b => b.visszaMennyiseg != '' && b.visszaHatarido);
        }
        cikkek.push(submitObj);
        setCikkek(cikkek);
      } else {
        let array = [...cikkek];
        const editedIdx = cikkek.findIndex(c => c.id == id);
        let submitObj = {};
        submitObj.id = id;
        submitObj.new = isBontas ? cikkek[editedIdx].new : newCikk;
        submitObj.cikk = cikk;
        submitObj.cikkNev = cikkNev;
        submitObj.cikkId = cikk && cikk.id;
        submitObj.mennyiseg = mennyiseg;
        submitObj.visszaMennyiseg = visszaMennyiseg;
        submitObj.hatarido = hatarido ? TimeFormatter.formatDate(hatarido) : null;
        submitObj.visszaHatarido =  visszaHatarido ? TimeFormatter.formatDate(visszaHatarido) : null;
        submitObj.nettoEgysegar = nettoEgysegar;
        submitObj.bruttoEgysegar = Number(removeSpacesFromString(bruttoEgysegar));
        submitObj.nettoBeszerzesiar = nettoBeszerzesiar;
        submitObj.bruttoBeszerzesiar = Number(removeSpacesFromString(bruttoBeszerzesiar));
        submitObj.megjegyzes = megjegyzes;
        submitObj.eredeti = cikkek[editedIdx].eredeti;
        submitObj.priceInputEgyseg = priceInputEgyseg;
        if(isBontas){
          // A splice + fix editedIdx miatt megfordul a sorrend, a reverse ezt kompenzálja
          bontottArray.reverse().forEach(bontas => {
            let bontasObj = {
              ...submitObj,
              id: generateUUID(),
              eredeti: { id },
              new: true,
              hatarido: TimeFormatter.formatDate(bontas.hatarido),
              mostbontott: true,
              mennyiseg: bontas.mennyiseg,
              visszaMennyiseg: bontas.visszaMennyiseg,
              visszaHatarido: bontas.visszaHatarido ? TimeFormatter.formatDate(bontas.visszaHatarido) : null,
              nettoBeszerzesiar: bontas.mennyiseg * submitObj.nettoEgysegar,
              bruttoBeszerzesiar: bontas.mennyiseg * submitObj.bruttoEgysegar,
            };
            array.splice(editedIdx + 1, 0, bontasObj);
          });
        }
        array[editedIdx] = submitObj;
        setCikkek(array);
      }
      toggleCikkModal();
    }

    const renderBontas = () => {
      return( isBontas &&
        <React.Fragment>
          <div className="row" style={ROW_STYLE}>
              <div className="col-md-12" style={{paddingRight: '2px'}}>
                <h6>Cikkek felbontása</h6>
              </div>
          </div>
          <div className='row mb-2'>
            <div className='col-md-3'>
              Határidő:
            </div>
            <div className='col-md-2'>
              Mennyiség:
            </div>
            <div className='col-md-2'>
              Vissz.ig. mennyiség:
            </div>
            <div className='col-md-3'>
              Visszaigazolt határidő:
            </div>
          </div>
          {bontasArray.map( (bontott, idx, array) => (
          <div className="row" key={idx}>
            <div className="col-md-3" >
              <DatePicker
                id={"hatarido" + idx}
                name={"hatarido" + idx}
                value={bontott.hatarido && new Date(bontott.hatarido) }
                onChange={(e,v) => setBontottValue(v, idx, 'hatarido')}
                containerClassName={ "organw-date-time"}
                // format="YYYY-MM-DD HH:mm:ss"
                // parse={['YYYY-MM-DD', 'YYYY-MM-DD HH:mm']}
                messages={{ dateButton: "dátum" , timeButton: "idő"}}
              />
            </div>
            <div className="col-md-2">
              <RFField
                style={{textAlign: "right"}}
                name={"mennyiseg" + idx}
                id={"mennyiseg" + idx}
                value={bontott.mennyiseg}
                onChange={(e,v) => setBontottValue(v, idx, 'mennyiseg')}
              />
            </div>
            <div className="col-md-2">
              <RFField
                style={{textAlign: "right"}}
                name={"visszaMennyiseg" + idx}
                id={"visszaMennyiseg" + idx}
                value={bontott.visszaMennyiseg}
                onChange={(e,v) => setBontottValue(v, idx, 'visszaMennyiseg')}
              />
            </div>
            <div className="col-md-3" >
              <DatePicker
                id={"visszaHatarido" + idx}
                name={"visszaHatarido" + idx}
                value={bontott.visszaHatarido && new Date(bontott.visszaHatarido) }
                onChange={(e,v) => setBontottValue(v, idx, 'visszaHatarido')}
                containerClassName={ "organw-date-time"}
                // format="YYYY-MM-DD HH:mm:ss"
                // parse={['YYYY-MM-DD', 'YYYY-MM-DD HH:mm']}
                messages={{ dateButton: "dátum" , timeButton: "idő"}}
              />
            </div>
            <div className="col-md-1">
              <Button color="secondary" style={{ width: "100%" }} type="button" onClick={() => setBontasArray([...bontasArray, {id: generateUUID(), new: true, visszaMennyiseg: '', visszaHatarido: null}])}>
                <i className="fa fa-plus"></i>
              </Button>
            </div>
            {array.length > 1 &&
              <div className="col-md-1">
                <Button color="secondary" style={{ width: "100%" }} type="button" onClick={() => setBontasArray(bontasArray.filter(b => b.id != bontott.id))}>
                  <i className="fa fa-trash"></i>
                </Button>
              </div>
            }
          </div>
          ))}
        </React.Fragment>
      );
    }

    const renderForm = () => {
      const selectStyles = {
        control: base => ({
          ...base,
          '&:focus': { borderColor: 'red' }, // border style on hover
          border: '1px solid lightgray', // default border color
          boxShadow: 'none', // no box-shadow
          borderRadius: '0'
        }),
      };
      return (
        <React.Fragment>
          {!id &&
            <div className="row" style={ROW_STYLE}>
              <div className="col-md-12" style={{paddingRight: '2px'}}>
                <Label for="cikkCsoportArray">Cikkcsoport:</Label>
                <AsyncSelect
                  styles={selectStyles}
                  name="cikkCsoportArray"
                  id="cikkCsoportArray"
                  placeholder="Kezdj el gépelni..."
                  noOptionsMessage={() => 'Nincs keresési eredmény'}
                  onChange={v => setCikkcsoportArray(v)}
                  loadOptions={_.debounce(loadCikkCsoportOptions, 1000)}
                  getOptionLabel={option => option.nev}
                  getOptionValue={option => option.id}
                  value={cikkCsoportArray}
                  isDisabled={isElkuldott}
                  isClearable
                  defaultOptions
                  isMulti
                />
              </div>
            </div>
          }
          <div className="row" style={ROW_STYLE}>
            <div className="col-md-12" style={{paddingRight: '2px'}}>
              <Label for="cikk">Cikk: *</Label>
              <AsyncSelect
                styles={selectStyles}
                name="cikk"
                id="cikk"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={handleCikkChange}
                loadOptions={_.debounce(loadCikkOptions, 1000)}
                getOptionLabel={option => option.megnevezes}
                getOptionValue={option => option.id}
                value={cikk}
                isDisabled={isElkuldott}
                isClearable
                //defaultOptions
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4" style={ROW_STYLE}>
              <RFField
                label={'Megnevezés: '}
                name={"megnevezes"}
                id={"megnevezes"}
                value={cikkNev}
                onChange={(e,v) => setCikkNev(v)}
                disabled={isElkuldott}
              />
            </div>
            <div className="col-md-4" style={ROW_STYLE}>
              <RFField
                label={'Cikkszám: '}
                name={"cikkszam"}
                id={"cikkszam"}
                value={cikk ? cikk.cikkszam : ''}
                disabled
              />
            </div>
            <div className="col-md-2" style={ROW_STYLE}>
              <RFField
                label={'Me.: '}
                name={"mennyisegiEgyseg"}
                id={"mennyisegiEgyseg"}
                value={cikk ? cikk.mennyisegiEgyseg : ''}
                disabled
              />
            </div>
            <div className="col-md-2" style={ROW_STYLE}>
              <RFField
                label={'ÁFA%: '}
                name={"afa"}
                id={"afa"}
                value={cikk ? cikk.aktualisAfaErtek : ''}
                disabled
              />
            </div>
          </div>
          <div className="row">
            <div className={parentId && !isBontas ? "col-md-8" : "col-md-6"} style={ROW_STYLE}>
              <RFField
                label={'Mennyiség: *'}
                style={{textAlign: "right"}}
                name={"mennyiseg"}
                id={"mennyiseg"}
                value={mennyiseg}
                onChange={handleMennyisegChange}
                required
                disabled={isElkuldott}
              />
            </div>
            {!isBontas && isElkuldott &&
            <div className="col-md-4" style={ROW_STYLE}>
              <RFField
                label={'Visszaigazolt mennyiség: '}
                style={{textAlign: "right"}}
                name={"visszaMennyiseg"}
                id={"visszaMennyiseg"}
                value={visszaMennyiseg}
                onChange={(e,v) => setVisszaMennyiseg(v)}
              />
            </div>
            }
          {/* </div>  
          <div className="row"> */}
            <div className={parentId && !isBontas ? "col-md-8" : "col-md-6"} style={ROW_STYLE}>
              <DatePicker
                label={'Határidő: *'}
                id="hatarido"
                name="hatarido"
                value={hatarido && new Date(hatarido) }
                disabled={isElkuldott}
                onChange={(e,v) => setHatarido(v === '' ? null : v)}
                containerClassName={ "organw-date-time"}
                // format="YYYY-MM-DD HH:mm:ss"
                // parse={['YYYY-MM-DD', 'YYYY-MM-DD HH:mm']}
                messages={{ dateButton: "dátum" , timeButton: "idő"}}
                required
              />
            </div>
            {!isBontas && isElkuldott &&
            <div className="col-md-4" style={ROW_STYLE}>
              <DatePicker
                label={'Visszaigazolt határidő: '}
                id="visszaHatarido"
                name="visszaHatarido"
                value={visszaHatarido && new Date(visszaHatarido) }
                onChange={(e,v) => setVisszaHatarido(v === '' ? null : v)}
                containerClassName={ "organw-date-time"}
                // format="YYYY-MM-DD HH:mm:ss"
                // parse={['YYYY-MM-DD', 'YYYY-MM-DD HH:mm']}
                messages={{ dateButton: "dátum" , timeButton: "idő"}}
                required
              />
            </div>
            }
          </div>
          <PriceInputComponent
            disabledArray={[(!mennyiseg || !cikk || isElkuldott), (!mennyiseg || !cikk || isElkuldott)]}
            valueArray={[nettoEgysegar, afaEgysegar, bruttoEgysegar, nettoBeszerzesiar, afaBeszerzesiar, bruttoBeszerzesiar]}
            onChangeArray={[(priceArray) => handleArInput(priceArray, true), (priceArray) => handleArInput(priceArray, false)]}
            afa={cikk && cikk.aktualisAfaErtek}
            mennyiseg={mennyiseg}
            tizedesjegy={penznem && penznem.tizedesjegy}
          />
          {renderBontas()}
          <div className="row">
            <div className="col-md-12">
              <RFField
                label={'Megjegyzés: '}
                type="textarea"
                name={"megjegyzes"}
                id={"megjegyzes"}
                value={megjegyzes}
                disabled={isElkuldott}
                onChange={(e, v) => setMegjegyzes(v)}
              />
            </div>
          </div>
        </React.Fragment>
      );
    }

    const renderButtons = () => {
      return(
        <div className="row">
          <div className="col-md-12">
            <Button
              className="btn-cursor-pointer"
              color="success"
              type="submit"
            >
              Mentés
            </Button>
            <Button type="button" color="secondary" onClick={() => toggleCikkModal()}>
              Mégsem
            </Button>
          </div>
        </div>
      );
    }

    return (
      <Modal isOpen={cikkModal} toggle={() => toggleCikkModal(!cikkModal)} backdrop="static" size="lg">
        <RFForm
          modal
          onSubmit={saveSzallitoiCikkRendeles}
          title={'Cikk '+ (id ? 'módosítása' : 'hozzáadása')}
          footer={renderButtons()}
        >
          <div className="row">
            <div className="col-md-12">
              {renderForm()}
            </div>
          </div>
        </RFForm>
      </Modal>
    );

};

export default SzallitoiCikkForm;
